import { jsx as a } from "react/jsx-runtime";
import { H as o } from "./chunks/index-UjijAVoZ.js";
const r = ({ children: e, ...t }) => /* @__PURE__ */ a(
  o,
  {
    className: "font-semibold text-center text-blue-500",
    level: "4",
    tagName: "h1",
    ...t,
    children: e
  }
);
r.displayName = "LockScreen.Heading";
export {
  r as default
};
